// Key code constants
var CODE_ESCAPE = 'Escape';

export { CODE_ESCAPE };
//# sourceMappingURL=keycode.esm.js.map
